module.exports = __webpack_public_path__ + "img/hr-dead-tree-desert-09.b16217da.png";